import * as actionTypes from '../consts/actionTypes';

export function cleanMsgError() {
    return {
        type: actionTypes.RESET_SEND_REQUEST_FAILURE,
        payload: ''
    };
}